// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609240126/js/" + chunkId + "." + {"44":"709869ff","225":"c7977d4b","481":"b58067a8","486":"48c65472","770":"261550f2"}[chunkId] + ".0.7579562315107103.chunk.js";
};